import { h } from 'preact'
import FirebaseComponent from './FirebaseComponent'
import * as firebase from 'firebase'
import './Navbar.css'
import { route } from 'preact-router'
import { Link } from 'preact-router/match'
import moment from 'moment'

class Navbar extends FirebaseComponent {
  constructor() {
		super()

    this.state = {
		  navbarIcon: 'https://s3.amazonaws.com/oil-and-gas-organiser-images/images/logo.png',
    }
    this.rightSideButtons = this.rightSideButtons.bind(this)
    this.signOutUser = this.signOutUser.bind(this)
  }

  signOutUser(event) {
    firebase.database().ref(`accounts/${this.state.uid}/connections/lastOnline`)
      .set(moment().format())
      .then(() => {
        firebase.auth().signOut()
          .then(() => {
            route('/', true)
          })
      })
  }

  rightSideButtons() {
    if (this.state.isAuthed) {
      return (
        <ul className="nav navbar-nav navbar-right">
          <li><Link activeClassName="active" href="/planner" onClick={() => route('/planner', true)}><i class="fa fa-calendar" aria-hidden="true"></i></Link></li>
          <li><Link activeClassName="active" href="/competencies" onClick={() => route('/competencies', true)}><i class="fa fa-file" aria-hidden="true"></i></Link></li>
          <li><Link activeClassName="active" href="/travel" onClick={() => route('/travel', true)}><i class="fa fa-plane" aria-hidden="true"></i></Link></li>
          <li><Link activeClassName="active" href="/medical" onClick={() => route('/medical', true)}><i class="fa fa-heartbeat" aria-hidden="true"></i></Link></li>
          <li><Link activeClassName="active" href="/profile" onClick={() => route('/profile', true)}><i class="fa fa-user" aria-hidden="true"></i></Link></li>
          <li><Link onClick={this.signOutUser}><i class="fa fa-sign-out" aria-hidden="true"></i></Link></li>
        </ul>
      )
    } else {
      return (
        <ul className="nav navbar-nav navbar-right">
          <li><Link activeClassName="active" href="/signin" onClick={() => route('/signin', true)}>Sign in</Link></li>
          <li><Link activeClassName="active" href="/signup" onClick={() => route('/signup', true)}>Sign up</Link></li>
        </ul>
      )
    }
  }

  render() {
    return (
			<nav className="navbar navbar-fixed-top navbar-inverse">
				<div className="container">
					<div className="navbar-header">
						<button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
							<span class="sr-only">Toggle navigation</span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
							<span class="icon-bar"></span>
						</button>

            <a onClick={() => route('/', true)}><img src={this.state.navbarIcon} className="logo" alt="OAGO"/></a>
					</div>
					<div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
						{this.rightSideButtons()}
					</div>
				</div>
			</nav>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/Navbar.js